module.exports = __webpack_public_path__ + "static/media/sort-amount-desc.024da84a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/sort-amount-desc.svg
// module id = 3520
// module chunks = 7